import { Component, Input } from '@angular/core';
import { TextDividerComponent } from '../text-divider/text-divider.component';


@Component({
  selector: 'app-section-subtitle',
  imports: [],
  templateUrl: './section-subtitle.component.html',
  styleUrls: ['./section-subtitle.component.scss'],
})
export class SectionSubstitleComponent {
}
